<template>
  <div class="">
    <embed-instructions-wrapper />
  </div>
</template>

<script>
import EmbedInstructionsWrapper from '@/components/Cancellation/EmbedCode/EmbedInstructionsWrapper.vue';

export default {
  name: 'SettingsEmbed',
  components: {
    EmbedInstructionsWrapper,
  },
};
</script>
